// helpers
import { wistiaReveal } from '../../../assets/js/helpers';

export default class SubmoduleVideo {

	static selector = 'submodule-video';

	// class variables

	config = {
		wistiaId: null
	};

	el = {};

	states = {
		activeDescription: null,
		total: 0,
		wistiaApiRef: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaPlay: container.querySelector(`.${this.constructor.selector}__cta-play`),
			wistiaVideo: container.querySelector(`.${this.constructor.selector}__wistia`)
		};

		this.config.wistiaId = this.el.container.dataset.wistiaId;

		if (this.el.wistiaVideo) {
			this.initialize();
		}
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add and remove listeners

	#addEventListeners = () => {
		this.el.ctaPlay.addEventListener('click', this.#onVideoPlayClick);
	}

	#removeEventListeners = () => {
		this.el.ctaPlay.removeEventListener('click', this.#onVideoPlayClick);
	}

	// listener methods

	#onVideoPlayClick = () => {
		if (!this.states.wistiaApiRef) {
			this.states.wistiaApiRef = Wistia.api(this.config.wistiaId);
		}

		this.el.wistiaVideo.classList.add('is-active');
		this.states.wistiaApiRef.play();

		wistiaReveal(this.states.wistiaApiRef).then(() => {
			this.el.wistiaVideo.classList.add('is-in');
		});
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
